import { Box } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { Outlet } from "react-router-dom";
import MainNavbar from "./MainNavbar";
import Footer from "./Footer";
import AuthenticationModal from "./AuthenticationModal";
import ContactModal from "./ContactModal";

const Landing = () => {
  const navbarContainerRef = useRef<HTMLDivElement | null>(null);
  const [navbarHeight, setNavbarHeight] = useState(64);

  useEffect(() => {
    const navbarElement = navbarContainerRef.current;
    if (!navbarElement) {
      return;
    }

    const updateNavbarHeight = () => {
      setNavbarHeight(navbarElement.getBoundingClientRect().height);
    };

    updateNavbarHeight();

    const resizeObserver = new ResizeObserver(updateNavbarHeight);
    resizeObserver.observe(navbarElement);

    window.addEventListener("resize", updateNavbarHeight);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener("resize", updateNavbarHeight);
    };
  }, []);

  return (
    <Box
      width="100%"
      minHeight="100vh"
      sx={{
        bgcolor: "background.default",
        "--landing-navbar-height": `${navbarHeight}px`,
      }}
    >
      <Box ref={navbarContainerRef}>
        <MainNavbar
          modals={(modalVisible, setModalVisible) => [
            <AuthenticationModal
              modalVisible={modalVisible}
              setModalVisible={setModalVisible}
              key="authentication"
            />,
          ]}
        />
      </Box>
      <Box>
        <Outlet />
      </Box>
      <Footer
        modals={(modalVisible, setModalVisible) => [
          <ContactModal
            modalVisible={modalVisible}
            setModalVisible={setModalVisible}
            key="contact"
          />,
        ]}
      />
    </Box>
  );
};

export default Landing;
